import { Link } from "gatsby"
import React from "react"
import styled from "styled-components"
import colors from "../../../../styles/colors"
import fonts from "../../../../styles/fonts"
import breakpoints from "../../../../styles/breakpoints"

const StyledLink = styled(Link)`
  ${fonts.ivyPrestoLight};
  text-decoration: none;
  color: inherit;
  font-size: 12px;
  letter-spacing: 1px;
  color: ${(props) => (props.featured ? colors.lightGreen : colors.trueBlack)};
  line-height: 1.16;
  text-align: left;
  display: inline-block;
  padding: 0 10px 23px;
  text-transform: lowercase;
  text-decoration: ${(props) => (props.active ? "underline" : "none")};
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 14px;
    padding: 0 20px 23px;
  }
`

const StyledButton = styled.button`
  ${fonts.ivyPrestoLight};
  padding: 0;
  border: none;
  font-size: 12px;
  letter-spacing: 1px;
  color: ${(props) => (props.featured ? colors.lightGreen : colors.trueBlack)};
  line-height: 1.16;
  padding: 12px 30px;
  text-align: left;
  text-transform: lowercase;
  padding: 0 10px 23px;
  background: transparent;
  text-decoration: ${(props) => (props.active ? "underline" : "none")};
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 14px;
    padding: 0 16 23px;
  }
`

const StyledA = styled.a`
  ${fonts.ivyPrestoLight};
  text-decoration: none;
  color: inherit;
  font-size: 12px;
  letter-spacing: 1px;
  color: ${(props) => (props.featured ? colors.lightGreen : colors.trueBlack)};
  line-height: 1.16;
  text-align: left;
  display: inline-block;
  text-transform: lowercase;
  padding: 0 10px 23px;
  text-decoration: ${(props) => (props.active ? "underline" : "none")};
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }

  @media (min-width: ${breakpoints.xl}) {
    font-size: 14px;
    padding: 0 16 23px;
  }
`

const SingleLink = ({ link, handleBespokeFormPopup }) => {
  if (link.openBespokeForm) {
    return (
      <StyledButton
        onClick={handleBespokeFormPopup}
        featured={link.isFeatured ? 1 : 0}
      >
        {link.title}
      </StyledButton>
    )
  }

  if (link.externalLink) {
    return (
      <StyledA
        href={link.externalLink}
        featured={link.isFeatured ? 1 : 0}
      >
        {link.title}
      </StyledA>
    )
  }
  return (
    <StyledLink to={link.link} featured={link.isFeatured ? 1 : 0}>
      {link.title}
    </StyledLink>
  )
}

export default SingleLink
